// Module
var code = "<uib-alert type=\"danger\" close=\"vm.errorMessage = null\" ng-if=\"vm.errorMessage\">{{vm.errorMessage}}</uib-alert><task-photos-old ng-if=\"!!vm.photos &amp;&amp; vm.task &amp;&amp; vm.hasAccess\" photos=\"vm.photos\" diagnosis=\"vm.diagnosis\" task=\"vm.task\" visit=\"vm.visit\" errorMessage=\"vm.errorMessage\" on-reload=\"vm.reload()\" on-reject=\"vm.reject(payload)\" on-approve=\"vm.approve(payload)\"></task-photos-old>";
// Exports
var _module_exports =code;;
var path = 'app/views/visits/detail/sections/photos/exam/examPhotosOld.html';
var angular = require('angular');
angular.module('pims').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;